export default __webpack_public_path__ + "static/media/index.23a8a955.less";